<template>
  <nav id="maintopbar" class="pl-0 navbar navbar-expand-md navbar-dark bg-menu-nc" :style="cssNavbar">
    <!--<router-link :to="this.ruta" class="navbar-brand">
      <img src="@/assets/css/content-layout/assets/img/nuevo-capital.svg" width="120" height="60" class="d-inline-block align-top" alt="Nuevo Capital">
    </router-link>-->
	<a href="#" class="toggle-menu" @click.prevent="SidebarCollapse()">
		<i class="material-icons chevron-right">chevron_right</i>
		<i class="material-icons chevron-left">chevron_left</i>
	</a>
	<LineaNegocio />
    <div class="collapse navbar-collapse" id="navbarNavDropdown">
      <ul class="navbar-nav ml-auto">
	  <li class="nav-item align-self-center position-relative mr-3" v-if="EmpresasBusqueda">
		<button :disabled="EmpresaBuscada.value==null" class="btn btn-primary px-0 btn-select-search" title="Abrir Ficha" @click="fichaEmpresa()">
			<i class="material-icons">open_in_new</i>
		</button>
			<multiselect
				v-model="EmpresaBuscada"
				:options="EmpresasBusqueda"
				select-label="Seleccionar"
				selectedLabel="Seleccionado"
				deselectLabel="Quitar"
				placeholder="Buscar"
				label="text"
				track-by="value"
				:disabled="false"
				:allow-empty="false"
				class="select-search"
				@input="fichaEmpresa()">
				<template slot="option" slot-scope="props">
					<div
						class="option__desc"
						:class="[props.option.estado === 'Activas' ? 'op_activa' : 'op_inactiva']"
					>
						<span class="option__title">
							<div class="d-inline" v-if="props.option.estado === 'Activas'">
								<!-- Icono activas -->
								<svg style="width:18px;height:18px;color:rgb(175 222 180);" viewBox="0 0 24 24">
									<path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" />
								</svg>
							</div>
							<div class="d-inline" v-else>
								<!-- Icono Inactivas -->
								<svg style="width:18px;height:18px;color:rgb(214 196 166);" viewBox="0 0 24 24">
									<path fill="currentColor" d="M17,13H7V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
								</svg>
							</div>
							{{ props.option.text }}
						</span>
					</div>
				</template>
			</multiselect>
        </li>
        <li class="nav-item align-self-center">
          <router-link class="nav-link" :to="{ name: 'Perfil' }" >
            <span class="fa fa-user"></span> {{useraccess}}
          </router-link>
        </li>
        <li class="nav-item align-self-center">
          <a class="nav-link"  @click="CerrarSesion()">
            <span class="fa fa-lock"></span> Cerrar sesión
          </a>
        </li>
      </ul>
    </div>
	<div class="barrita" :style="'background-color:'+colorBarra"></div>
  </nav>
</template>

<style scoped>
.bg-menu-nc{background-color: var(--bg-navbar-color);}
#maintopbar .toggle-menu .material-icons{color:var(--text-navbar-color);}
.navbar-dark .navbar-nav .nav-link{color:var(--text-navbar-color);}
</style>

<script>
import Multiselect from 'vue-multiselect'
import LineaNegocio from '@/components/ui/LineaNegocio'
import { mapState, mapActions } from 'vuex'
export default {
	name: 'Navbar',
	methods: {
		...mapActions([
			'logout',
			'doDpaso',
			'doCollapsemenu',
			'doEmpresas'
		]),
		CerrarSesion () {
			this.logout()
		},

		buscarEmpresas () {
			if (this.empresasList !== null) {
				this.EmpresasBusqueda = this.empresasList
				return false
			}
			this.axios.post(this.apiurl + 'empresas/getEmpresas', {
				idUsusario: this.idUser
			}, this.auth2).then(response => {
				this.EmpresasBusqueda = response.data.comboEmpresa
				try { this.doEmpresas(this.EmpresasBusqueda) } catch (err) { this.doEmpresas(null) }
				this.isLoading = false
			 }).catch(error => {
				console.log(error)
				this.isLoading = false
			})
		},
		fichaEmpresa () {
			this.doDpaso(this.EmpresaBuscada.value)
		 let routeData =
		 this.$router.resolve({ name: 'FichaCliente',
		 params: { idcliente: this.EmpresaBuscada.value }
		 })
			window.open(routeData.href, '_blank')
		},
		SidebarCollapse: function () {
			this.doCollapsemenu(!this.collapsemenu)
		}
	},
	mounted () {
		if (!this.accessToken) { this.$router.push('Login') }
		this.buscarEmpresas()
		this.accessRoles.forEach((value, key) => {
			this.roles.push(value.rol)
		})
		// Controlamos que tenga un unico rol y ademas sea verificador, para que el logo de NC, nos lleve a verificacion
		if (this.roles.length === 1 && (this.roles[0] === 'Verificador' || this.roles[0] === 'Verificador Agente')) {
			this.ruta = '/Verificacion'
		} else {
			this.ruta = '/Resumen'
		}
	},
	data () {
		// Variables a usar para el retorno de las respuestas
		return {
			roles: [],
			// Ruta por defecto
			ruta: '',
			EmpresaBuscada: [],
			EmpresasBusqueda: []
		}
	},
	components: {
		Multiselect,
		LineaNegocio
	},
	computed: {
		...mapState([
			'accessToken',
			'logginIn',
			'loginError',
			'apiurl',
			'useraccess',
			'idUser',
			'auth2',
			'dPaso1',
			'accessRoles',
			'collapsemenu',
			'empresasList',
			'colorBarra',
			'bgNavbarColor',
			'textNavbarColor',
			'borderNavbarColor'
		]),
		cssNavbar () {
			return {
				'--bg-navbar-color': this.bgNavbarColor,
				'--text-navbar-color': this.textNavbarColor,
				'--border-navbar-color': this.borderNavbarColor
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/layout/Navbar.vue